<template>
  <footer>
    <div class="inner">
      <div class="grid">
        <div v-if="settings && settings.footer_logos">
          <div :key="logo.image" v-for="logo in settings.footer_logos"><img :src="logo.image" class="guide" :alt="logo.alt" /></div>
        </div>
        <div v-if="mainMenu && mainMenu.length">
          <div class="heading">Quick Links</div>
          <ul>
            <li :key="menupage.ItemID" v-for="menupage in mainMenu">
              <page-link :to="menupage.url == 'home' ? '/' : menupage.url">{{ menupage.name }}</page-link>
            </li>
          </ul>
        </div>
        <div v-if="settings && settings.service_list">
          <div class="heading">Our Services</div>
          <span class="list" v-html="settings.service_list.replace(/[\n\r]/g, '<br>')"></span>
        </div>
        <div class="contact">
          <page-link class="logo" to="/">
            <img alt="W E Pinder" src="../assets/logo-old.png" />
          </page-link>
          <div v-if="settings && settings.telephone">
            <a :href="'tel:' + settings.telephone.replace(/ /g, '')" class="number">{{ settings.telephone }}</a>
          </div>
          <p class="address" v-html="settings.address.replace(/[\n\r]/g, '<br>')" v-if="settings && settings.address"></p>
        </div>
      </div>
      <div class="copyright">
        <span>
          &copy; {{ new Date().getFullYear() }} - W.E. Pinder<br />
          Website designed & developed by
          <a href="https://chameleoncreative.marketing" rel="noreferrer" target="_blank">Chameleon Creative</a>
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex"
import { mapGetters } from "vuex"

export default {
  name: "Footer",
  computed: {
    ...mapState(["settings"]),
    ...mapGetters(["mainMenu"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer {
  background: #53453c;
  color: white;
  padding-top: 6rem;
}

.copyright {
  text-align: center;
  font-size: 1.2rem;
  padding: 2rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.288);
  margin-top: 2rem;
}

.copyright span {
  opacity: 0.7;
}

.heading {
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.guide {
  width: 50%;
  max-width: 17rem;
  margin-bottom: 2rem;
}

.grid ul,
.grid li {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.grid li {
  margin-bottom: 0.5rem;
  opacity: 0.7;
}

.list {
  opacity: 0.7;
  line-height: 1.5;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2fr;
}

.logo img {
  width: 20rem;
  margin-bottom: 2rem;
}

.contact {
  text-align: right;
}

.number {
  font-size: 2.5rem;
}

.address {
  margin-top: 2rem;
  font-size: 1.7rem;
}

.minor {
  border-top: 1px solid rgba(255, 255, 255, 0.288);
  padding-top: 2rem;
  margin-top: 4rem;
  display: table;
  width: 100%;
}

.minor ul,
.minor li {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-block;
}

.minor ul {
  padding-top: 1rem;
}

.minor li {
  padding-right: 2rem;
}

.minor img {
  float: right;
  height: 4rem;
  margin-left: 2rem;
}

.minor a:hover {
  text-decoration: underline;
}

.rounded {
  border-radius: 2rem;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .grid > div {
    width: 23%;
    margin-right: 2%;
    float: left;
  }
}

@media screen and (max-width: 750px) {
  .grid {
    grid-template-columns: 1fr;
  }

  .contact,
  .grid > div {
    text-align: center;
    padding-bottom: 3rem;
  }

  .grid li {
    display: inline-block;
    padding: 0 1rem;
  }

  .minor {
    text-align: center;
  }

  .minor img {
    float: none;
    margin-bottom: 0.5rem;
  }

  .minor ul {
    display: block;
  }
}
</style>
